import {
    Grid,
    Box,
    Checkbox,
    FormControlLabel,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    FormControl
} from "@mui/material";
import AgreeText from "./AgreeText";
import ClearIcon from "@mui/icons-material/Clear";
import { useState } from 'react';
import RegisterForm from "./RegisterForm";

function RegisterConfirm2(props) {
    const [openForm, setOpenForm] = useState(false);

    const clickOpenForm = () => {
        setOpenForm(true);
    };

    const clickCloseForm = () => {
        setOpenForm(false);
    };

    const {goNextPage, goPreviousPage} = props;

    return (
        <Box
            container
            height='100%'
            direction='column'
            justifyContent='center'
            overflow='hidden'>
            <Box
                sx={{
                    overflow: 'scroll',
                    padding: '0 20px'
                }}>
                {/* <Box
                    sx={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        marginTop: '20px'
                    }}>
                개인정보 수집 및 이용에 대한 동의
                </Box> */}
                <AgreeText></AgreeText>
                {/* <Box sx={{ height: '120px' }}></Box> */}
            </Box>
            {/* <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    width: '100%',
                    textAlign: 'center',
                    padding: '15px 0 20px',
                    background: 'white'
                }}>
                <Box
                    sx={{
                        marginBottom: '5px'
                    }}>
                    개인정보 수집 및 이용에 동의합니다.
                </Box>
                <Button variant="contained" sx={{ width: "40%", margin: "5px", background: "#0092a2" }} onClick={goNextPage}>예</Button>
                <Button variant="outlined" sx={{ width: "40%", margin: "5px", border: "1px solid gray", color: "gray" }} onClick={goPreviousPage}>아니오</Button>
            </Box> */}
        </Box>
    )
}
export default RegisterConfirm2;